import React from 'react';
const links = [{
  label: 'Estrategia',
  href: '#estrategia'
}, {
  label: 'Terminal',
  href: '#terminal'
}, {
  label: 'Acceso VIP',
  href: '#acceso'
}];
export function SiteHeader() {
  return <header className="sticky top-0 z-50 w-full border-b border-line bg-ink/85 backdrop-blur-md" data-id="element-74" data-mp="1nng05koa49br">
      <div className="mx-auto flex h-16 w-full max-w-[1400px] items-center justify-between px-6 lg:px-10" data-id="element-75" data-mp="1inbhpp3t94iw">
        <a href="#top" className="group flex items-baseline gap-2" data-id="element-76" data-mp="uxh5n9rbfjzp">
          <span className="text-[15px] font-semibold tracking-tight text-white" data-id="element-77" data-mp="qwnhqgdvi56t">
            Indicadores
          </span>
          <span className="font-mono text-[13px] font-medium tracking-[0.18em] text-gold-vip" data-id="element-78" data-mp="14worymg12oyy">
            VIP
          </span>
        </a>

        <nav aria-label="Principal" className="flex items-center gap-1" data-id="element-79" data-mp="zw0q15q9gnpy">
          {links.map(link => <a key={link.href} href={link.href} className="rounded px-3 py-2 text-[13px] text-white/60 transition-colors duration-150 ease-out hover:text-white focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-cyan-vip" data-id="element-80" data-mp="2gdoibcitetqc">
              {link.label}
            </a>)}
        </nav>
      </div>
    </header>;
}